export default __webpack_public_path__ + "static/media/notes3.706378ba.png";